var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-shop-page"},[_c('app-header'),_c('div',{staticClass:"page-content"},[_c('ShopInfoForm',{attrs:{"shopId":_vm.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }